'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rebass = require('rebass');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var MacWindow = function MacWindow(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#fbfbfb' : _ref$color,
      _ref$src = _ref.src,
      src = _ref$src === undefined ? 'https://via.placeholder.com/640x480' : _ref$src,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['style', 'color', 'src', 'children']);

  return _react2.default.createElement(_rebass.Box, _extends({
    bg: color,
    style: _extends({
      borderRadius: 4,
      overflow: 'hidden',
      boxShadow: 'inset 0 1px 0 rgba(255,255,255,.6), 0 22px 70px 4px rgba(0,0,0,0.56), 0 0 0 1px rgba(0, 0, 0, 0.3)'
    }, style)
  }, props), _react2.default.createElement(_rebass.Box, {
    pl: 1,
    style: {
      background: 'linear-gradient(#ebebeb, #d5d5d5)',
      borderBottom: '1px solid #b1aeb1'
    }
  }, _react2.default.createElement(_rebass.Dot, null), _react2.default.createElement(_rebass.Dot, null), _react2.default.createElement(_rebass.Dot, null)), src ? _react2.default.createElement(_rebass.Image, {
    src: src
  }) : children);
};

MacWindow.displayName = 'MacWindow';
MacWindow.propTypes = {
  src: _propTypes2.default.string,
  style: _propTypes2.default.object,
  color: _propTypes2.default.string,
  children: _propTypes2.default.any
};
exports.default = MacWindow;